export default __webpack_public_path__ + "static/media/catbg.d22ee647.png";